import { Component, Input, ViewEncapsulation } from "@angular/core";
import { MenuData } from '../models/menu-data';

@Component({
    selector: "tidy-menu-header",
    templateUrl: "tidy-menu-header.component.html",
    styleUrls: ['./tidy-menu-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TidyMenuHeader {
  @Input() menuData: MenuData;

  constructor() {
  }
}
